import { RouteRecordRaw } from 'vue-router';
import { RouteMetaType, ExtendedRouteMetaType } from '@/router/routes/types';
import { ENTRY_POINTS } from '@constants/entry-points';

type ErrorRouteMetaType = RouteMetaType & {
  requiresAuth: false;
  requiresTenant: false;
  requiresTenantAdmin: false;
  requiresEnterpriseLicense: false;
};

const META_DEFAULT: ErrorRouteMetaType = Object.freeze({
  requiresAuth: false,
  requiresTenant: false,
  requiresTenantAdmin: false,
  requiresEnterpriseLicense: false,
  redirectOnError: ENTRY_POINTS.PATH.UNAUTHORIZED(),
});

const getMeta = (
  extendedMeta: ExtendedRouteMetaType<ErrorRouteMetaType> = {},
): ErrorRouteMetaType => ({ ...META_DEFAULT, ...extendedMeta });

const routes: Array<RouteRecordRaw> = [
  {
    path: '/404',
    name: '404',
    component: () => import('@views/error/Error404View.vue'),
    meta: getMeta({ title: 'Page Not Found' }),
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('@views/error/Error404View.vue'),
    meta: getMeta({ title: 'Page Not Found' }),
  },
];

export default routes;
